import {Project, ProjectId} from "common/types/project";

export default function getBaseProjectId(
  projects: Array<Pick<Project, "id" | "alternate_projects">>,
  projectId: ProjectId,
): ProjectId | undefined {
  const project = projects.find(({id}) => Number(id) === Number(projectId));
  if (project?.alternate_projects?.length) {
    return undefined;
  }
  return projects.find(({alternate_projects}) =>
    alternate_projects?.some(
      alternate => Number(alternate.project_id) === Number(projectId),
    ),
  )?.id;
}
